import { BaseEntity, Transform, toDate } from './base';

export class DeliveryLocation extends BaseEntity {
  lat: number;
  lng: number;
  locationName: string;
  details?: string;
  street?: string;
  city?: string;
  nickname?: string;
  state?: string;
  country?: string;
  persistent: boolean;

  @Transform(toDate)
  updatedAt: Date;
}



// WEBPACK FOOTER //
// ./src/models/delivery-location.ts